interface PwaInstallDialogProps {
  open: boolean;
  onClose: () => void;
}

export function PwaInstallDialog({ open, onClose }: PwaInstallDialogProps) {
  if (!open) return null;

  return (
    <div className="modal-backdrop pwa-install-backdrop" role="presentation" onMouseDown={onClose}>
      <section
        className="pwa-install-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="pwa-install-title"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <header>
          <div className="pwa-install-icon" aria-hidden="true">
            Ч
          </div>
          <div>
            <h2 id="pwa-install-title">Установить «Рабочий чат»</h2>
            <p>Откроется как обычное приложение — без строки браузера и плавающего экрана.</p>
          </div>
          <button type="button" onClick={onClose} aria-label="Закрыть инструкцию">
            ×
          </button>
        </header>
        <ol>
          <li>
            Откройте этот адрес в <strong>Safari</strong>.
          </li>
          <li>
            Нажмите кнопку <strong>«Поделиться»</strong> — квадрат со стрелкой вверх.
          </li>
          <li>
            Выберите <strong>«На экран “Домой”»</strong>, затем <strong>«Добавить»</strong>.
          </li>
        </ol>
        <p className="pwa-install-note">
          После установки запускайте чат зелёной иконкой с главного экрана телефона.
        </p>
        <button className="primary-button" type="button" onClick={onClose}>
          Понятно
        </button>
      </section>
    </div>
  );
}
